<!-- 首页 -->
<template>
  <div class="index">
    <!-- 地图 -->
    <div id="container"></div>
    <!-- 全局音频 -->
    <audio :src="$global.ImgUrl + this.audioAll" id="audioPlayer"></audio>
    <!-- 路线规划 -->
    <div id="panel"></div>
    <!-- 顶部 -->
    <div class="top" v-show="topShow">
      <div class="topSearch">
        <div class="leftDay">
          <div class="dayIcon">
            <img :src="$global.ImgUrl + this.weatherData.url" alt="" />
          </div>
          <div class="dayText">
            {{ this.weatherData.low }}~{{ this.weatherData.high }}
          </div>
        </div>
        <div class="rightSearch" @click="searchPageShow = true">
          <div class="searchIcon"></div>
          <span>搜索点位、路线</span>
        </div>
      </div>
      <div class="topNav">
        <div :class="[
          'navContent',
          navDataIndex == index ? 'navContent-active' : '',
        ]" v-for="(item, index) in initDataNav" :key="index" @click="changeNavFn(index, item.id)">
          <div class="navList">
            <div class="navIcon">
              <img :src="
                navDataIndex == index
                  ? $global.ImgUrl + item.listIcon
                  : $global.ImgUrl + item.listSelectIcon
              " alt="" />
            </div>
            <span class="navText">{{ item.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 右侧选择 -->
    <div class="rightSelect" v-show="rightShow">
      <div class="selectContent1">
        <van-switch v-model="checked" size="16px" active-color="#FAD850" @input="onLelayerInput" />
        <div class="lineText2">手绘</div>
      </div>
      <div class="selectContent2" @click="skipRoutePage()">
        <div class="lineIcon2"></div>
        <div class="lineText2">路线</div>
      </div>
    </div>
    <!-- 底部列表 -->
    <div class="bottomAll" v-show="bottomShow">
      <div class="bottomList" @click="bottomBtnFn()">
        <div class="listBtn" v-show="bottomListBtn">
          <div class="listIcon"></div>
          <div class="listText">查看列表</div>
        </div>
        <div class="listBtn-active" v-show="bottomListBtnActive"></div>
      </div>
      <div class="listContent" v-show="listContent">
        <div class="conDetail" v-for="(item, index) in initDatapoints" :key="index" @click="listDetailFn(index)">
          <div class="leftImg">
            <img :src="$global.ImgUrl + item.cover" alt="" />
          </div>
          <div class="rightIntro">
            <div class="introName">{{ item.name }}</div>
            <div class="introBottom">
              <div class="bottomAddress">
                <div class="addressIcon"></div>
                <div class="addressName">{{ item.address }}</div>
              </div>
              <div class="bottomLook">
                <div class="lookLeft">
                  <div class="lookIcon"></div>
                  <div class="lookNum">{{ item.visitNumber }}</div>
                </div>
                <div class="lookRight">距你{{ item.distancePoint }}m</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <div class="skipWindow" v-show="skipWindowShow">
      <div class="conDetail">
        <div class="leftImg" v-show="this.skipWindowData.cover">
          <img :src="$global.ImgUrl + this.skipWindowData.cover" alt="" />
        </div>
        <div class="rightIntro">
          <div class="introName">{{ this.skipWindowData.name }}</div>
          <div class="introBottom">
            <div class="bottomAddress">
              <div class="addressIcon"></div>
              <div class="addressName">{{ this.skipWindowData.address }}</div>
            </div>
            <div class="bottomLook">
              <div class="lookLeft" v-show="this.skipWindowData.cover">
                <div class="lookIcon"></div>
                <div class="lookNum">
                  {{ this.skipWindowData.visitNumber }}
                </div>
              </div>
              <div class="lookRight">
                距你{{ this.skipWindowData.distancePoint }}m
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="skipBottom">
        <!-- 音频播放 -->
        <div class="audio" v-show="this.skipWindowData.audio">
          <div class="audio-box">
            <!-- 音频播放模块 -->
            <div class="player-box">
              <div class="audio-left flex center" id="audioPlayer" @click="audioPlay(skipWindowData.id)">
                <a v-if="!playing">
                  <img src="./image/button_play.svg" alt="" />
                </a>
                <a v-else>
                  <img src="./image/icon_zanting.svg" alt="" />
                </a>
              </div>
              <div class="audio-right flex center column">
                <div class="progress-bar-bg" id="progressBarBg" @click="progressBarBg">
                  <span id="progressDot" :style="'left:' + dotLeft + '%'"></span>
                  <div class="progress-bar" id="progressBar" :style="'width:' + barWidth + '%'"></div>
                </div>
                <div class="audio-time">
                  <span class="audio-length-current" id="audioCurTime">{{
                      audioCurTime
                  }}</span>/
                  <span class="audio-length-total">{{ duration }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="skipSelect">
          <div class="skipReserve" v-show="this.skipWindowData.viewUrl" @click="skipOutUrlFn(skipWindowData.viewUrl)">
            预定
          </div>
          <div class="leftSkip">
            <div class="skipText" @click="lookDetailPageFn(skipWindowData.id)">
              查看详情
            </div>
          </div>
          <div class="rightSkip" @click="
            shipNavgationFn(skipWindowData.longitude, skipWindowData.latitude)
          ">
            <div class="skipIcon"></div>
            <div class="skipText">导航</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 导航 -->
    <div class="navigation" v-show="navShow">
      <div class="leftCon" @click="backNavFn()">
        <div class="leftIcon"></div>
        <div class="leftText">退出</div>
      </div>
      <div class="rightCon" @click="
        toNavigationFn(
          skipWindowData.address,
          skipWindowData.latitude,
          skipWindowData.longitude
        )
      ">
        <div class="leftIcon"></div>
        <div class="leftText">前往导航</div>
      </div>
    </div>
    <!-- 详情页面 -->
    <div class="detail" v-show="detailShow">
      <!-- 轮播图 -->
      <div class="swiper">
        <van-swipe @change="onChange" :autoplay="3000">
          <van-swipe-item v-for="(item, index) in this.detailData.imgs" :key="index">
            <img :src="$global.ImgUrl + item" alt="" />
          </van-swipe-item>
          <template #indicator>
            <div class="custom-indicator">
              <div class="imgIcon">
                <img src="./image/icon_picture.svg" alt="" />
              </div>
              <span>{{ current + 1 }}/{{ detailData.imgNumber }}</span>
            </div>
          </template>
        </van-swipe>
      </div>
      <!-- 介绍卡片 -->
      <div class="introCard">
        <div class="introName">{{ this.detailData.name }}</div>
        <div class="change">
          <div class="introYear" v-show="this.detailData.openTime">
            <div class="yearIcon"></div>
            <div class="yearText">{{ this.detailData.openTime }}</div>
          </div>
          <div class="introAddress">
            <div class="addressIcon"></div>
            <div class="addressText">{{ this.detailData.address }}</div>
          </div>
        </div>
      </div>
      <!-- 简介 -->
      <div class="synopsis" v-show="this.detailData.openTime">
        <div class="chat" v-show="this.detailData.opening">
          <div class="chatTime">
            <span class="timeName">开业时间</span>
            <span class="timeCon">{{ this.detailData.opening }}</span>
          </div>
          <div class="chatTel">
            <span class="telName">电话咨询 </span>
            <span class="telCon">{{ this.detailData.mobile }}</span>
            <div class="tel" @click="callPhone(detailData.mobile)">
              <span class="telIcon"></span>
              <span class="telText">拨打</span>
            </div>
          </div>
        </div>
        <div class="introTitle" v-show="!this.detailData.opening">景点详情</div>
        <div class="syCon" v-html="this.detailData.pointInfo" v-show="this.detailData.pointInfo"></div>
      </div>
      <!-- 周边 -->
      <div :class="['round', this.detailData.audio ? '' : 'round-active']">
        <div class="roundAll">
          <div class="roundTitle">
            <div class="titleLeft">周边推荐</div>
            <div class="titleRight" @click="moreMarker()">
              <span>更多推荐</span>
              <span class="toIcon"></span>
            </div>
          </div>
          <div class="roundNav">
            <div :class="['navList', navIndex == index ? 'navList-active' : '']" v-for="(item, index) in initDataNav"
              :key="index" @click="roundNavFn(index, item.id)">
              {{ item.name }}
            </div>
          </div>
          <div class="roundCon">
            <div class="conList" v-for="(item, index) in roundData" :key="index" @click="skipIndexMaker(item.id)">
              <div class="listImg">
                <img :src="$global.ImgUrl + item.cover" alt="" />
              </div>
              <div class="listIntro">
                <div class="introName">{{ item.name }}</div>
                <div class="introCon">距你{{ item.distancePoint }}m</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 返回 -->
      <div class="bottom">
        <!-- 音频播放 -->
        <div class="audio" v-show="this.detailData.audio">
          <div class="audio-box">
            <!-- 音频播放模块 -->
            <div class="player-box">
              <div class="audio-left flex center" id="audioPlayer" @click="audioPlay(detailData.id)">
                <a v-if="!playing">
                  <img src="./image/button_play.svg" alt="" />
                </a>
                <a v-else>
                  <img src="./image/icon_zanting.svg" alt="" />
                </a>
              </div>
              <div class="audio-right flex center column">
                <div class="progress-bar-bg" id="progressBarBg" @click="progressBarBg">
                  <span id="progressDot" :style="'left:' + dotLeft + '%'"></span>
                  <div class="progress-bar" id="progressBar" :style="'width:' + barWidth + '%'"></div>
                </div>
                <div class="audio-time">
                  <span class="audio-length-current" id="audioCurTime">{{
                      audioCurTime
                  }}</span>/
                  <span class="audio-length-total">{{ duration }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="roundSelect">
          <div class="seOne" @click="backIndexPage()">
            <span class="oneIcon"></span>
            <span class="oneText">返回</span>
          </div>
          <div class="seTwo" v-show="this.detailData.viewUrl" @click="skipOutUrlFn(detailData.viewUrl)">
            <span class="twoIcon"></span>
            <span class="twoText">预定</span>
          </div>
          <div class="seThree" @click="shipNavgationFn(detailData.longitude, detailData.latitude)">
            <span class="threeIcon"></span>
            <span class="threeText">导航</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 更多推荐 -->
    <div class="rounder" v-show="roundShow">
      <div class="roundCon" v-for="(item, index) in roundData" :key="index" @click="skipIndexMaker(item.id)">
        <div class="conImg">
          <img :src="$global.ImgUrl + item.cover" alt="" />
        </div>
        <div class="conIntro">
          <div class="introName">{{ item.name }}</div>
          <div class="introDetail">
            <div class="leftDe">
              <span class="leftIcon"></span>
              <span class="leftText">396</span>
            </div>
            <div class="rightDe">
              <span class="rightText">距你{{ item.distancePoint }}m</span>
            </div>
          </div>
        </div>
      </div>
      <div class="backPage">
        <div class="backBtn" @click="roundShow = false">
          <div class="backIcon">
            <img src="./image/icon_back.svg" alt="" />
          </div>
          <div class="backText">返回</div>
        </div>
      </div>
    </div>
    <!-- 路线页面 -->
    <div class="route" v-show="routePageShow">
      <!-- 头部 -->
      <div class="top">
        <div class="topLeft" @click="backIndex()">
          <div class="backIcon">
            <img src="./image/icon_back.svg" alt="" />
          </div>
          <div class="backText">返回</div>
        </div>
        <div class="topTitle">路线</div>
      </div>
      <!-- 内容 -->
      <div class="content">
        <div class="contents">
          <div class="contentList" v-for="(item, index) in routeData" :key="index" @click="lineDetailPage(item.id)">
            <div class="listImg">
              <img :src="$global.ImgUrl + item.cover" alt="" />
            </div>
            <div class="listDetail">
              <div class="detailName">
                {{ item.name }}
              </div>
              <div class="detailData">
                <div class="leftCon">
                  <div class="leftIcon"></div>
                  <div class="leftNum">{{ item.pointNum }}</div>
                </div>
                <div class="rightCon">
                  <div class="rightIcon"></div>
                  <div class="rightNum">{{ item.imgNum }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 路线详情页 -->
    <!-- 头部 -->
    <div class="topDet" v-show="topDetShow">
      <div class="topLeft" @click="backLinePage()">
        <div class="backIcon">
          <img src="./image/icon_back.svg" alt="" />
        </div>
        <div class="backText">返回</div>
      </div>
      <div class="topTitle" v-show="topDetailShowOld">路线详情</div>
      <div class="topTitle" v-show="topDetailShow">
        {{ this.lineDetailData.name }}
      </div>
    </div>
    <!-- 底部详情 -->
    <div class="bottomDet" v-show="bottomDetShow">
      <div class="bottomTop" @click="bottomtopFn()">
        <div class="topIcon"></div>
      </div>
      <div class="bottomCon">
        <div class="conName">
          {{ this.lineDetailData.name }}
        </div>
        <div class="conLine">
          <div class="lineCon">
            <div class="startMarker">
              <div class="start"></div>
              <div class="startName">{{ this.startName }}</div>
            </div>
            <div class="toIcon"></div>
            <div class="endMarker">
              <div class="end"></div>
              <div class="endName">{{ this.endName }}</div>
            </div>
          </div>
          <div class="lineDetail">
            <div class="detLeft">
              全路线有<span class="detTT">{{
                  this.lineDetailData.pointNum
              }}</span>个景点
            </div>
            <div class="detLeft">
              大约需要<span class="detTT">{{
                  this.lineDetailData.duration
              }}</span>小时
            </div>
          </div>
        </div>
        <div class="lineIntro">路线介绍</div>
      </div>
      <div class="bottomIntro" v-show="bottomIntro">
        <div class="introImg">
          <div class="allList">
            <div class="imgList" v-for="(item, index) in this.lineDetailData.imgs" :key="index">
              <img :src="$global.ImgUrl + item" alt="" />
            </div>
          </div>
        </div>
        <div class="introText" v-html="this.lineDetailData.intro"></div>
        <div class="toStart">
          <div class="startBtn" @click="startBtnFn()">
            开始游玩
            <span class="startIcon"></span>
          </div>
        </div>
      </div>
    </div>
    <!-- 搜索页面 -->
    <div class="search" v-show="searchPageShow">
      <!-- 搜索框 -->
      <div class="search-box">
        <input v-model="keyword" type="text" />
        <div class="serchbtn"></div>
        <span class="onCancle" @click="onCancle()">取消</span>
      </div>
      <!-- 搜索内容 -->
      <div class="searchContent">
        <div class="sContent" v-for="(item, index) in this.searchData" :key="index" v-show="searchShow">
          <div class="scenicItem" @click="backPrev(item.id, item.pointType, item.type)">
            <div class="leftItem">
              <div class="itemIcon">
                <img :src="$global.ImgUrl + item.img" alt="" />
              </div>
              <div class="itemName">{{ item.name }}</div>
            </div>
            <div class="rightItem">{{ item.typeName }}</div>
          </div>
        </div>
        <div class="noResult" v-show="noResultShow">
          查不到相关数据，换个词试试~
        </div>
      </div>
    </div>
    <!-- 异性轮播图 -->
    <div class="banner-box-swiper" v-show="containerShow">
      <swiper v-if="carouselList.length > 0" :options="swiperOption" ref="mySwiper">
        <swiper-slide class="swiper-slide" v-for="(item, index) in carouselList" :key="index">
          <div class="topTitle">
            <div class="leftCon">
              <span class="leftIcon">{{ index + 1 }}</span>
              <span class="leftText">{{ item.pointName }}</span>
            </div>
            <div class="rightCon" @click="closeCard()"></div>
          </div>
          <div class="centerCon">
            <div class="centerLeft">
              {{ item.intro }}
            </div>
            <div class="centerRight">
              <img :src="$global.ImgUrl + item.cover" alt="" />
            </div>
          </div>
          <div class="bottomCon">
            <div class="leftAll">
              <div class="leftIndex" @click="toLeftFn(index)"></div>
              <div @click="audioPlay(item.pointId)">
                <div class="bottomLeft" v-if="!playing"></div>
                <div class="bottomLeft-active" v-else></div>
              </div>
              <div class="rightIndex" @click="toRightFn(index)"></div>
            </div>
            <div class="bottomCenter" @click="lookDetailPageFn(item.pointId)">
              查看详情
            </div>
            <div class="bottomRight" @click="shipNavgationFn(item.longitude, item.latitude)">
              <span class="rightIcon"></span>
              <span class="rightText">导航</span>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <!-- 定位 -->
    <PositionBtn :mapObj="mapObj" :scenicBound="[]" :isLocation="isLocation" @event="change($event)"></PositionBtn>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  indexApi,
  listApi,
  weatherApi,
  pointDetailApi,
  roundDetailApi,
  routeApi,
  lineDetailApi,
  searchApi,
} from "../../request/api/index";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import PositionBtn from "../../components/PositionBtn/PositionBtn.vue";
import "swiper/dist/css/swiper.css";
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);
let vm = null;
// 节流函数
const delay = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { swiper, swiperSlide, PositionBtn },
  data() {
    //这里存放数据
    return {
      isLocation: false,
      navDataIndex: 0, //导航切换显示
      checked: true, // 手绘开关
      bottomListBtn: true,
      bottomListBtnActive: false,
      skipWindowShow: false, //弹窗显示
      detailShow: false, //详情页面显示
      roundShow: false, //更多推荐
      routePageShow: false, //显示路线页面
      topShow: true, //顶部显示
      rightShow: true, //右侧显示
      current: 0, //轮播图的的下标
      //底部列表按钮
      listContent: false,
      showHotel: false, //酒店显示
      bottomShow: true, //底部列表显示
      navShow: false, //导航显示
      // 音频播放
      duration: "00:00", //音频总时长
      audioCurTime: "00:00", //音频当前时间
      playing: false, //音频播放中的状态
      barWidth: 0, //已播放条的宽度值
      dotLeft: 0, //进度点的left值
      hasContent: null, //从extData中判断点位类型
      audioAll: null, //全局音频
      curAudio: "", //当前音频的id
      // 请求类数据
      initDataNav: null, //初始数据
      initDataPoi: null, //初始地图点位
      poiTypeId: 1, //导航的id
      initDatapoints: null, //地图marker点
      weatherData: [], //天气的数据
      //地图类
      mapObj: null, //初始化地图
      markerArrIcon: [], //marker点位的图标
      markers: [], //当前的点位
      activeMarker: null, //当前点击的点位
      skipWindowData: [], //弹窗数据
      resLocation: [], //定位的坐标
      lineLongitude: "", //规划线路的经度
      lineLatitude: "", //规划线路的维度
      riding: null, //路线规划
      polyline: null, //路线的全局变量
      leLayer: null, //瓦片
      isShowLelayer: true, //是否展示瓦片s
      //详情页数据
      navIndex: 0,
      pointDetailId: "", //从主页传过来的id
      detailData: [], //请求到的数据
      typeId: 1, //导航的类型id
      roundData: [], //周边数据
      //线路页数据
      routeData: null, //线路页数据
      topDetShow: false, //头部详情显示
      bottomIntro: false, //底部详情的显示
      bottomDetShow: false,
      lineDetailId: "", //线路详情id
      lineDetailData: [], //线路详情数据
      newLinesData: [], //去除默认点位的数据
      startName: "", //开始的景点
      endName: "", //结束的景点
      topDetailShow: false, //头部名显示
      topDetailShowOld: true,
      //搜索页面
      keyword: "", //搜索框输入的内容
      searchData: [], //搜索的数据
      searchShow: true, //显示搜索的内容
      noResultShow: false, //搜索不到结果
      searchPageShow: false,
      //异性轮播图
      carouselList: [],
      active: 0,
      carouselIndex: 0,
      // 异形轮播图配置
      swiperOption: {
        effect: "coverflow",
        coverflowEffect: {
          rotate: 0, // slide做3d旋转时Y轴的旋转角度 (默认50).
          stretch: -30, // 每个slide之间的拉伸值 越大slide靠得越紧.
          depth: 100, // slide的位置深度 值越大z轴距离越远 看起来越小.
          modifier: 1, // depth和rotate和stretch的倍率 相当于(depth*modifier、rotate*modifier、stretch*modifier) 值越大这三个参数的效果越明显(默认1).
          slideShadows: false, // 开启slide阴影 (默认 true)
        },
        // 默认选中中间一张
        // centeredSlides: true,
        slideToClickedSlide: true,
        //上下按钮点击轮播效果
        on: {
          slideChange: function () {
            // console.log(this.realIndex);
            let e = vm.lineDetailData.lineMarkerArr[this.realIndex];
            vm.markerLineClick(e);
            vm.changeMarkAudioPlay();
          },
        },
      },
      containerShow: false, //轮播显示
    };
  },
  created() {
    vm = this;
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  //监控data中的数据变化
  watch: {
    //watch title change
    keyword() {
      delay(() => {
        const value = this.keyword.trim();
        if (!value) {
          //判断输入框的值是否为空  如果为空 直接返回不在执行
          this.searchShow = false;
          // return;
        } else {
          this.getSearchData(); //获取搜索的内容
        }
      }, 300);
    },
  },
  //方法集合
  methods: {
    //初始化地图
    initMap() {
      let that = this;
      this.mapObj = new AMap.Map("container", {
        view: new AMap.View2D({
          // 创建地图二维视口
          // center: new AMap.LngLat(120.752914, 30.838732),
          center: new AMap.LngLat(
            this.initDataPoi.longitude,
            this.initDataPoi.latitude
          ),
          zoom: this.initDataPoi.showZoom, //设置地图初始的的缩放级别
          // zoom: 15, //设置地图初始的的缩放级别
          rotation: 0, //设置地图旋转角度
        }),
        // zooms: [1, 30], //地图可缩放的级别
        zooms: [this.initDataPoi.minZoom, this.initDataPoi.maxZoom], //地图可缩放的级别
        lang: "zh_cn", //设置地图语言类型，默认：中文简体
        features: ["bg", "road", "building"], //去除高德的瓦片
      });
      // 瓦片加载
      this.leLayer = new AMap.TileLayer({
        // 图块取图地址,加了s=1就是下沙景区限制
        tileUrl:
          "https://map.gingkoswan.com/upload_resource/41993/[z]/[x]_[y].png",
        // tileUrl: "http://192.168.1.250:88/41993/[z]/[x]_[y].png",
        zIndex: 10,
      });
      // console.log(this.leLayer);
      this.leLayer.setMap(this.mapObj);
      this.getListData(); //列表数据
      this.mapObj.on("complete", function () {
        console.log("complete");
        // 开始定位
        that.isLocation = true; //定位组件 定位事件
      });
    },
    //得到的自身位置
    change(data) {
      this.resLocation = data;
      // var marker = new AMap.Marker({
      //   position: new AMap.LngLat(this.resLocation[0], this.resLocation[1]),
      //   offset: new AMap.Pixel(-10, -10),
      //   content:
      //     "" +
      //     '<div class="custom-content-marker">' +
      //     `<div class="contain"></div>` +
      //     "</div>", // 添加 Icon 图标 URL
      // });
      // this.mapObj.add(marker);
      this.getListData();
    },
    //创建marker点位
    createMarker() {
      let that = this;
      for (var i in this.initDatapoints) {
        var markIcon, markSelectIcon;
        markIcon = new AMap.Icon({
          // 图标尺寸
          size: new AMap.Size(32, 34),
          // 图标的取图地址
          image: this.$global.ImgUrl + this.markerArrIcon.markIcon,
          // 图标所用图片大小
          imageSize: new AMap.Size(32, 34),
          // 图标取图偏移量
          // imageOffset: new AMap.Pixel(-9, -3),
        });
        markSelectIcon = new AMap.Icon({
          // 图标尺寸
          size: new AMap.Size(32, 34),
          // 图标的取图地址
          image: this.$global.ImgUrl + this.markerArrIcon.markSelectIcon,
          // 图标所用图片大小
          imageSize: new AMap.Size(32, 34),
          // 图标取图偏移量
          // imageOffset: new AMap.Pixel(-9, -3),
        });
        let marker = new AMap.Marker({
          position: new AMap.LngLat(
            this.initDatapoints[i].longitude,
            this.initDatapoints[i].latitude
          ), //marker点的位置
          icon: markIcon,
          offset: new AMap.Pixel(-13, -30), //marker内容的偏移量
          extData: {
            pioData: this.initDatapoints[i],
            markIcon: markIcon,
            markSelectIcon: markSelectIcon,
          },
        });
        //标记点的文本内容
        marker.setLabel({
          offset: new AMap.Pixel(-2, 30), //设置文本标注偏移量
          content: this.initDatapoints[i].name, //设置文本标注内容
          direction: "center", //设置文本标注方位
        });
        // marker点击监听事件
        AMap.event.addListener(marker, "click", function (e) {
          that.markerClick(this);
        });
        //添加marker到地图
        this.markers.push(marker);
      }
    },
    //创建路线marker点位
    createLineMarker() {
      let that = this;
      let arr = this.lineDetailData.linePoints;
      console.log(arr);
      this.lineDetailData.lineMarkerArr = [];
      for (var i in arr) {
        if (arr[i].hasContent) {
          // console.log(arr[i].longitude);
          // 点标记显示内容，HTML要素字符串
          var markIcon, markSelectIcon;
          markIcon = new AMap.Icon({
            // 图标尺寸
            size: new AMap.Size(32, 34),
            // 图标的取图地址
            image: this.$global.ImgUrl + arr[i].markIcon,
            // 图标所用图片大小
            imageSize: new AMap.Size(32, 34),
            // 图标取图偏移量
            // imageOffset: new AMap.Pixel(-9, -3),
          });
          markSelectIcon = new AMap.Icon({
            // 图标尺寸
            size: new AMap.Size(32, 34),
            // 图标的取图地址
            image: this.$global.ImgUrl + arr[i].markSelectIcon,
            // 图标所用图片大小
            imageSize: new AMap.Size(32, 34),
            // 图标取图偏移量
            // imageOffset: new AMap.Pixel(-9, -3),
          });
          let marker = new AMap.Marker({
            position: new AMap.LngLat(arr[i].longitude, arr[i].latitude), //marker点的位置
            icon: markIcon,
            offset: new AMap.Pixel(-20, -50), //marker内容的偏移量
            extData: {
              pioData: arr[i],
              markIcon: markIcon,
              markSelectIcon: markSelectIcon,
            },
          });
          //标记点的文本内容
          marker.setLabel({
            offset: new AMap.Pixel(-2, 30), //设置文本标注偏移量
            content: arr[i].pointName, //设置文本标注内容
            direction: "center", //设置文本标注方位
          });
          // marker点击监听事件
          AMap.event.addListener(marker, "click", function (e) {
            that.markerLineClick(this);
          });
          this.lineDetailData.lineMarkerArr.push(marker);
        }
      }
    },
    // 瓦片异步控制开关
    onLelayerInput(checked) {
      this.checked = checked;
      if (checked) {
        this.leLayer.setMap(this.mapObj);
      } else {
        this.leLayer.setMap(null);
      }
    },
    //线路的线的数据处理
    lineArrData(data) {
      var arr = [];
      for (var i in data) {
        var arr1 = [data[i].longitude, data[i].latitude];
        arr.push(arr1);
      }
      this.polineShow(arr);
    },
    //线路显示
    polineShow(arr) {
      // console.log(arr);
      this.polyline = new AMap.Polyline({
        path: arr,
        isOutline: true,
        outlineColor: "#fff",
        borderWeight: 1,
        strokeColor: "#FF5A5A",
        strokeOpacity: 1,
        strokeWeight: 3,
        // 折线样式还支持 'dashed'
        strokeStyle: "solid",
        // strokeStyle是dashed时有效
        strokeDasharray: [10, 5],
        lineJoin: "round",
        lineCap: "round",
        zIndex: 700,
      });
      this.polyline.setMap(this.mapObj);
      // 缩放地图到合适的视野级别
      this.mapObj.setFitView([this.polyline]);
    },
    // 点位改成 点击之前的样式
    markerSetNomal(marker) {
      if (this.activeMarker) {
        marker.setIcon(marker.getExtData().markIcon);
      }
    },
    // 点位改成 点击之后的样式
    markerSetClicked(marker) {
      if (this.activeMarker) {
        marker.setIcon(marker.getExtData().markSelectIcon);
      }
    },
    //点击marker
    markerClick(e) {
      // console.log(e);
      this.mapObj.setCenter(e.getPosition());
      this.skipWindowData = e.getExtData().pioData;
      console.log(this.skipWindowData);
      if (this.activeMarker) {
        if (
          e.getExtData().pioData.id == this.activeMarker.getExtData().pioData.id
          // 如果已经有点被点击且 已经被点击的点和这次点击的点相同
        ) {
          if (this.skipWindowShow) {
            this.skipWindowShow = false;
            this.bottomShow = true;
            this.navShow = false;
            this.skipWindowData = [];
            this.markerSetNomal(this.activeMarker);
            this.changeMarkAudioPlay(); // 切换marker音频停止事件
          } else {
            this.navShow = false;
            this.skipWindowShow = true;
            this.bottomShow = false;
            this.markerSetClicked(this.activeMarker);
          }
          return;
        } else {
          this.skipWindowShow = true;
          this.markerSetNomal(this.activeMarker);
          this.changeMarkAudioPlay(); // 切换marker音频停止事件
        }
      }
      this.navShow = false;
      this.skipWindowShow = true;
      this.bottomShow = false;
      // this.riding.clear();
      e.setIcon(e.getExtData().markSelectIcon);
      this.activeMarker = e;
      this.riding.clear();
    },
    //点击线路的的点标记
    markerLineClick(e) {
      this.mapObj.setCenter(e.getPosition());
      if (this.activeMarker) {
        if (
          e.getExtData().pioData.id == this.activeMarker.getExtData().pioData.id
          // 如果已经有点被点击且 已经被点击的点和这次点击的点相同
        ) {
          this.markerSetNomal(this.activeMarker);
          // return;
        }
      }
      this.bottomDetShow = false;
      this.topDetailShow = true;
      this.topDetailShowOld = false;
      this.containerShow = true;
      this.riding.clear();
      // console.log(e.getExtData());
      e.setIcon(e.getExtData().markSelectIcon);
      this.activeMarker = e;
      for (var i in this.newLinesData.linePoints) {
        if (
          this.newLinesData.linePoints[i].pointId ==
          e.getExtData().pioData.pointId
        ) {
          this.$refs.mySwiper.swiper.slideTo(i, 340, false);
        }
      }
    },
    //跳转到导航
    toNavigationFn(address, longitude, latitude) {
      this.commonFun.openLocation(
        address,
        this.resLocation[0],
        this.resLocation[1],
        latitude,
        longitude
      );
    },
    // 路线规划
    lineplan() {
      var ridingOption = {
        map: this.mapObj,
        panel: "panel",
        policy: 1,
        hideMarkers: true,
        isOutline: true,
        outlineColor: "green",
        autoFitView: true,
      };
      this.riding = new AMap.Riding(ridingOption);
      //根据起终点坐标规划骑行路线
      this.riding.search(
        [this.resLocation[0], this.resLocation[1]],
        [this.lineLongitude, this.lineLatitude],
        function (status, result) {
          if (status === "complete") {
            console.log("骑行路线数据查询成功");
          } else {
            console.log("骑行路线数据查询失败" + result);
          }
        }
      );
    },
    //播轮图的切换
    onChange(index) {
      this.current = index;
    },
    //关闭卡片
    closeCard() {
      this.changeMarkAudioPlay();
      this.bottomDetShow = true;
      this.topDetailShow = false;
      this.topDetailShowOld = true;
      this.containerShow = false;
      if (this.containerShow == false) {
        this.changeMarkAudioPlay();
      }
    },
    //切换导航栏
    changeNavFn(index, id) {
      this.navDataIndex = index;
      if (index == 1) {
        this.showHotel = true;
      } else {
        this.showHotel = false;
      }
      this.markerArrIcon = this.initDataNav[index];
      this.poiTypeId = id;
      this.getListData();
      this.skipWindowShow = false;
      this.skipWindowData = [];
      this.changeMarkAudioPlay(); //切换时关闭音乐
    },
    //窗口导航打开导航
    shipNavgationFn(longitude, latitude) {
      this.detailShow = false;
      this.navShow = true;
      this.containerShow = false;
      this.skipWindowShow = false;
      this.lineLongitude = longitude;
      this.lineLatitude = latitude;
      this.lineplan();
    },
    //底部列表按钮
    bottomBtnFn() {
      if (this.bottomListBtn) {
        this.bottomListBtn = false;
        this.bottomListBtnActive = true;
        this.listContent = true;
      } else {
        this.bottomListBtnActive = false;
        this.bottomListBtn = true;
        this.listContent = false;
      }
    },
    //点击打开详情页面
    lookDetailPageFn(id) {
      console.log(111);
      this.detailShow = true;
      this.pointDetailId = id;
      this.containerShow = false;
      this.getDetailData(); //请求详情页的数据
      this.getRoundData(); //周边数据
      this.changeMarkAudioPlay();
      // console.log(this.pointDetailId);
    },
    //点击转到预定外联
    skipOutUrlFn(viewUrl) {
      window.location.href = viewUrl;
    },
    //点击列表内容
    listDetailFn(index) {
      // console.log(index);
      this.bottomListBtnActive = false;
      this.bottomListBtn = true;
      this.listContent = false;
      this.bottomShow = false;
      let e = this.markers[index];
      this.mapObj.setCenter(e.getPosition());
      this.skipWindowData = e.getExtData().pioData;
      if (this.activeMarker) {
        if (
          e.getExtData().pioData.id == this.activeMarker.getExtData().pioData.id
          // 如果已经有点被点击且 已经被点击的点和这次点击的点相同
        ) {
          if (this.skipWindowShow) {
            this.skipWindowData = [];
            this.markerSetNomal(this.activeMarker);
            this.changeMarkAudioPlay(); // 切换marker音频停止事件
          } else {
            this.markerSetClicked(this.activeMarker);
          }
          return;
        } else {
          this.skipWindowShow = true;
          this.markerSetNomal(this.activeMarker);
          this.changeMarkAudioPlay(); // 切换marker音频停止事件
        }
      }
      this.navShow = false;
      this.skipWindowShow = true;
      e.setIcon(e.getExtData().markSelectIcon);
      this.activeMarker = e;
    },
    //点击退出导航
    backNavFn() {
      if (this.topDetShow) {
        this.containerShow = true;
      } else {
        this.skipWindowShow = true; //弹窗显示
      }
      this.navShow = false;
      this.riding.clear();
    },
    //周边导航
    roundNavFn(index, id) {
      this.navIndex = index;
      this.typeId = id;
      this.getRoundData(); //周边数据
    },
    skipIndexMaker(id) {
      let that = this;
      this.poiTypeId = this.typeId;
      listApi(this.poiTypeId).then((res) => {
        if (res.msg == "请求成功") {
          this.initDatapoints = res.data;
          this.mapObj.remove(this.markers);
          this.markers = [];
          this.createMarker();
          this.mapObj.add(this.markers);
          for (var i in this.initDatapoints) {
            this.initDatapoints[i].distancePoint = ""; //人与点的距离
            var p1 = [this.resLocation[0], this.resLocation[1]];
            var p2 = [
              this.initDatapoints[i].longitude,
              this.initDatapoints[i].latitude,
            ];
            var dis = AMap.GeometryUtil.distance(p1, p2);
            if (dis) {
              this.initDatapoints[i].distancePoint = parseInt(dis);
            }
          }
          for (var i in this.initDatapoints) {
            if (this.initDatapoints[i].id == id) {
              console.log(i);
              let marker = that.markers[i];
              console.log(marker);
              that.markerClick(marker);
            }
          }
        }
      });
      this.navDataIndex = this.poiTypeId - 1;
      if (this.polyline) {
        this.mapObj.remove(this.lineDetailData.lineMarkerArr); //添加marker到地图
        this.lineDetailData.lineMarkerArr = [];
        this.mapObj.remove(this.polyline);
        this.polyline = null;
      }
      this.topDetShow = false;
      this.topShow = true;
      this.rightShow = true;
      this.detailShow = false;
      this.typeId = 1;
      this.navIndex = 0;
      this.roundShow = false;
    },
    //详情页点击返回
    backIndexPage() {
      this.detailShow = false;
      this.routePageShow = false;
      if (this.topDetShow) {
        this.containerShow = true;
      }
      this.changeMarkAudioPlay();
    },
    //更多推荐
    moreMarker() {
      this.detailShow = false;
      this.roundShow = true;
    },
    //拨打电话
    callPhone(phoneNumber) {
      window.location.href = "tel://" + phoneNumber;
    },
    //预定
    skipOutUrlFn(url) {
      window.location.href = url;
    },
    //点击路线页面
    skipRoutePage() {
      this.getRouteData(); //线路数据
      this.routePageShow = true;
      this.skipWindowShow = false;
    },
    //路线页面点击返回首页
    backIndex() {
      this.$router.replace({
        path: "/bank",
      });
    },
    //取消
    onCancle() {
      this.$router.replace({
        path: "/bank",
      });
    },
    //请求全域搜索的数据
    getSearchData() {
      searchApi(this.keyword).then((res) => {
        // console.log(res);
        this.searchData = res.data;
        console.log(this.searchData);
        if (this.searchData.length == 0) {
          this.noResultShow = true;
          this.searchShow = false;
        } else {
          console.log(111);
          this.searchShow = true;
          this.noResultShow = false;
        }
      });
    },
    //返回上一页打开相对应的景点
    backPrev(id, pointType, type) {
      if (type == "1") {
        let that = this;
        listApi(pointType).then((res) => {
          if (res.msg == "请求成功") {
            this.initDatapoints = res.data;
            console.log(this.initDatapoints);
            this.mapObj.remove(this.markers);
            this.markers = [];
            this.createMarker();
            this.mapObj.add(this.markers);
            for (var i in this.initDatapoints) {
              if (this.initDatapoints[i].id == id) {
                console.log(i);
                let marker = that.markers[i];
                console.log(marker);
                that.markerClick(marker);
              }
            }
            for (var i in this.initDatapoints) {
              this.initDatapoints[i].distancePoint = ""; //人与点的距离
              var p1 = [this.resLocation[0], this.resLocation[1]];
              var p2 = [
                this.initDatapoints[i].longitude,
                this.initDatapoints[i].latitude,
              ];
              var dis = AMap.GeometryUtil.distance(p1, p2);
              if (dis) {
                this.initDatapoints[i].distancePoint = parseInt(dis);
              }
            }
          }
        });
        this.navDataIndex = pointType - 1;
        console.log(this.navDataIndex);
      } else if (type == "2") {
        this.lineDetailPage(id);
      }
      this.searchPageShow = false;
    },
    //跳转到线路详情页面
    lineDetailPage(id) {
      this.topShow = false;
      this.rightShow = false;
      this.bottomShow = false;
      this.bottomIntro = false;
      this.mapObj.remove(this.markers);
      this.markers = [];
      this.topDetShow = true;
      this.bottomDetShow = true;
      this.lineDetailId = id;
      this.getLineDetailData();
      this.topDetailShowOld = true;
      this.topDetailShow = false;
      this.routePageShow = false;
    },
    //line显示底部简介内容
    bottomtopFn() {
      if (!this.bottomIntro) {
        this.bottomIntro = true;
      } else {
        this.bottomIntro = false;
      }
    },
    //开始游玩
    startBtnFn() {
      this.bottomDetShow = false;
      this.topDetailShow = true;
      this.topDetailShowOld = false;
      this.containerShow = true;
    },
    //点击返回路线页
    backLinePage() {
      this.changeMarkAudioPlay();
      this.containerShow = false;
      this.topDetShow = false;
      this.bottomDetShow = false;
      this.routePageShow = true;
      this.mapObj.remove(this.lineDetailData.lineMarkerArr); //添加marker到地图
      this.lineDetailData.lineMarkerArr = [];
      this.mapObj.remove(this.polyline);
      this.polyline = null;
    },
    //异性轮播图
    getCarouselList() {
      this.carouselList = this.newLinesData.linePoints;
    },
    toLeftFn(index) {
      this.$refs.mySwiper.swiper.slideTo(index - 1, 340, false);
    },
    toRightFn(index) {
      this.$refs.mySwiper.swiper.slideTo(index + 1, 340, false);
    },
    // 点击进度条跳到指定点播放
    // PS：此处不要用click，否则下面的拖动进度点事件有可能在此处触发，此时e.offsetX的值非常小，会导致进度条弹回开始处
    progressBarBg(e) {
      let audio = document.getElementById("audioPlayer");
      if (!audio.paused || audio.currentTime != 0) {
        // let pgsWidth = $(".progress-bar-bg").width();
        let pgsWidth =
          document.getElementsByClassName("progress-bar-bg")[0].offsetWidth;
        let rate = e.offsetX / pgsWidth;
        audio.currentTime = audio.duration * rate;
        this.updateProgress(audio);
      }
    },
    // 鼠标拖动进度点时可以调节进度
    // 只有音乐开始播放后才可以调节，已经播放过但暂停了的也可以
    // 鼠标按下时
    progressDot(e) {
      let that = this;
      let audio = document.getElementById("audioPlayer");
      let dot = document.getElementById("progressDot");
      if (!audio.paused || audio.currentTime != 0) {
        let oriLeft = dot.offsetLeft;
        let mouseX = e.clientX;
        let maxLeft = oriLeft; // 向左最大可拖动距离
        let maxRight =
          document.getElementById("progressBarBg").offsetWidth - oriLeft; // 向右最大可拖动距离

        // 禁止默认的选中事件（避免鼠标拖拽进度点的时候选中文字）
        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.returnValue = false;
        }

        // 禁止事件冒泡
        if (e && e.stopPropagation) {
          e.stopPropagation();
        } else {
          window.event.cancelBubble = true;
        }

        // 开始拖动
        document.onmousemove = function (e) {
          let length = e.clientX - mouseX;
          if (length > maxRight) {
            length = maxRight;
          } else if (length < -maxLeft) {
            length = -maxLeft;
          }
          let pgsWidth =
            document.getElementsByClassName("progress-bar-bg")[0].width;
          let rate = (oriLeft + length) / pgsWidth;
          audio.currentTime = audio.duration * rate;
          that.updateProgress(audio);
        };

        // 拖动结束
        document.onmouseup = function () {
          document.onmousemove = null;
          document.onmouseup = null;
        };
      }
    },
    // 音频播放停止事件
    audioPlay(id) {
      let that = this;
      let audio = document.getElementById("audioPlayer");
      if (this.curAudio != id) {
        audio.pause();
        this.playing = false;
        pointDetailApi(id).then((res) => {
          if (res.msg == "请求成功") {
            this.detailData = res.data;
            this.audioAll = this.detailData.audio;
            setTimeout(() => {
              audio.play();
            }, 300);
          }
        });
        this.curAudio = id;
        this.playing = true;
      } else {
        // 改变播放/暂停图片
        if (audio.paused) {
          audio.play();
          this.playing = true;
        } else {
          audio.pause();
          this.playing = false;
        }
      }
      // 监听音频播放时间并更新进度条
      audio.addEventListener(
        "timeupdate",
        function () {
          that.updateProgress(audio);
        },
        false
      );

      // 监听播放完成事件
      audio.addEventListener(
        "ended",
        function () {
          that.audioEnded();
        },
        false
      );
    },
    // 切换marker音频停止事件
    changeMarkAudioPlay() {
      let audio = document.getElementById("audioPlayer");
      // 改变播放/暂停图片
      if (audio.paused) {
        this.audioEnded();
        this.audioInit();
      } else {
        audio.pause();
        this.audioEnded();
        this.audioInit();
      }
    },
    // 更新进度条与当前播放时间 audio - audio对象
    updateProgress(audio) {
      let value = audio.currentTime / audio.duration;
      this.barWidth = value * 100;
      this.dotLeft = value * 100;
      this.audioCurTime = this.transTime(audio.currentTime);
      this.duration = this.transTime(audio.duration);
    },
    /**
     * 音频播放时间换算
     * @param {number} value - 音频当前播放时间，单位秒
     */
    transTime(value) {
      let time = "";
      let h = parseInt(value / 3600);
      value %= 3600;
      let m = parseInt(value / 60);
      let s = parseInt(value % 60);
      if (h > 0) {
        time = this.formatTime(h + ":" + m + ":" + s);
      } else {
        time = this.formatTime(m + ":" + s);
      }

      return time;
    },
    /**
     * 格式化时间显示，补零对齐
     * eg：2:4  -->  02:04
     * @param {string} value - 形如 h:m:s 的字符串
     */
    formatTime(value) {
      let time = "";
      let s = value.split(":");
      let i = 0;
      for (; i < s.length - 1; i++) {
        time += s[i].length == 1 ? "0" + s[i] : s[i];
        time += ":";
      }
      time += s[i].length == 1 ? "0" + s[i] : s[i];

      return time;
    },
    //  播放完成时把进度调回开始的位置
    audioEnded() {
      this.barWidth = 0;
      this.dotLeft = 0;
      this.playing = false;
      this.audioCurTime = "00:00";
    },
    audioInit() {
      let that = this;
      let audio = document.getElementById("audioPlayer");
      if (this.audioSrc != "") {
        audio.load();
        audio.addEventListener("canplay", function () {
          //监听audio是否加载完毕，如果加载完毕，则读取audio播放时间
          that.duration = that.transTime(audio.duration);
        });
      }
    },
    //详情页数据
    getDetailData() {
      pointDetailApi(this.pointDetailId).then((res) => {
        console.log(res);
        if (res.msg == "请求成功") {
          this.detailData = res.data;
          console.log(111);
          console.log(this.detailData);
        }
      });
    },
    //周边数据
    getRoundData() {
      roundDetailApi(this.pointDetailId, this.typeId).then((res) => {
        // console.log(res);
        if (res.msg == "请求成功") {
          this.roundData = res.data;
          for (var i in this.roundData) {
            this.roundData[i].distancePoint = ""; //人与点的距离
            var p1 = [this.resLocation[0], this.resLocation[1]];
            var p2 = [this.roundData[i].longitude, this.roundData[i].latitude];
            var dis = AMap.GeometryUtil.distance(p1, p2);
            if (dis) {
              this.roundData[i].distancePoint = parseInt(dis);
            }
          }
        }
      });
    },
    //首页数据
    getInitData() {
      indexApi().then((res) => {
        // console.log(res);
        if (res.msg == "请求成功") {
          this.initDataNav = res.data.leftStrips;
          this.initDataPoi = res.data.scenicInfo;
          this.markerArrIcon = this.initDataNav[0];
          // console.log(this.initDatapoints);
          this.initMap(); //初始化地图
        }
      });
    },
    //列表数据
    getListData() {
      listApi(this.poiTypeId).then((res) => {
        // console.log(res);
        if (res.msg == "请求成功") {
          this.initDatapoints = res.data;
          this.mapObj.remove(this.markers);
          this.markers = [];
          this.createMarker();
          this.mapObj.add(this.markers);
          for (var i in this.initDatapoints) {
            this.initDatapoints[i].distancePoint = ""; //人与点的距离
            var p1 = [this.resLocation[0], this.resLocation[1]];
            var p2 = [
              this.initDatapoints[i].longitude,
              this.initDatapoints[i].latitude,
            ];
            var dis = AMap.GeometryUtil.distance(p1, p2);
            if (dis) {
              this.initDatapoints[i].distancePoint = parseInt(dis);
            }
          }
        }
      });
    },
    //天气数据
    getWeatherData() {
      weatherApi().then((res) => {
        console.log(res);
        if (res.msg == "请求成功") {
          this.weatherData = res.data;
          console.log(this.weatherData);
        }
      });
    },
    //线路数据
    getRouteData() {
      routeApi().then((res) => {
        console.log(res);
        if (res.msg == "请求成功") {
          this.routeData = res.data;
        }
      });
    },
    //线路详情页数据
    getLineDetailData() {
      lineDetailApi(this.lineDetailId).then((res) => {
        console.log(res);
        if (res.msg == "请求成功") {
          this.lineDetailData = res.data;
          this.newLinesData = JSON.parse(JSON.stringify(this.lineDetailData));
          this.newLinesData.linePoints = [];
          for (var i in this.lineDetailData.linePoints) {
            if (this.lineDetailData.linePoints[i].hasContent != "0") {
              this.newLinesData.linePoints.push(
                this.lineDetailData.linePoints[i]
              );
            }
          }
        }
        this.startName = this.newLinesData.linePoints[0].pointName;
        this.endName =
          this.newLinesData.linePoints[
            this.newLinesData.linePoints.length - 1
          ].pointName;
        this.createLineMarker();
        this.lineArrData(this.lineDetailData.linePoints);
        this.mapObj.add(this.lineDetailData.lineMarkerArr); //添加marker到地图
        this.getCarouselList(); //异性轮播图
        // console.log(this.newLinesData.linePoints);
      });
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.searchList = JSON.parse(localStorage.getItem("keyword")) || []; //先读取local里存储的历史记录
    this.getInitData(); //首页初始数据
    this.getWeatherData(); //天气数据
  },
};
</script>
<style lang="less">
.index {
  width: 100%;
  height: 100vh;
  position: relative;

  //地图
  #container {
    width: 100%;
    height: 100%;
    position: relative;

    // 去除地图logo
    .amap-logo {
      display: none !important;
    }

    .amap-copyright {
      display: none !important;
      opacity: 0;
    }

    .contain {
      width: 1.5rem;
      height: 2rem;
      background: url("./image/Group 462.svg") no-repeat;
      background-size: 100%;
    }

    //marker的文本内容
    .amap-marker-label {
      position: absolute;
      z-index: 2;
      border: 1px solid white;
      border-radius: 2.1rem;
      background-color: white;
      opacity: 0.96;
      white-space: nowrap;
      cursor: default;
      padding: 3px 1rem;
      font-size: 1.2rem;
      box-shadow: 0rem 0.4rem 0.4rem 0rem rgba(0, 0, 0, 0.1);
    }
  }

  #panel {
    .amap-lib-driving {
      display: none;
    }
  }

  //顶部************************************************
  .top {
    width: 100%;
    background: linear-gradient(180deg,
        #fafafa,
        rgba(250, 250, 250, 0.96) 100%);
    position: absolute;
    top: 0;
    z-index: 100;

    // 搜索
    .topSearch {
      width: 100%;
      height: 5.6rem;
      padding: 1rem 1.6rem 0 2rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .leftDay {
        width: 6.1rem;
        height: 4.6rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;

        .dayIcon {
          width: 3rem;
          height: 3rem;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .dayText {
          width: 100%;
          height: 1.3rem;
          line-height: 1.3rem;
          text-align: center;
          font-size: 1.2rem;
          font-family: DIN, DIN-Bold;
          font-weight: 700;
          color: #333333;
          letter-spacing: 0rem;
        }
      }

      .rightSearch {
        width: 26rem;
        height: 4.6rem;
        opacity: 0.9;
        background: #ffffff;
        border-radius: 2.4rem;
        box-shadow: 0rem 0.2rem 0.8rem 0rem rgba(0, 0, 0, 0.04);
        padding: 1rem 1.6rem;
        display: flex;
        align-items: center;

        .searchIcon {
          width: 2.4rem;
          height: 2.4rem;
          background: url("./image/icon_search.svg") no-repeat;
          background-size: 100%;
          float: left;
          margin-right: 0.8rem;
        }

        span {
          font-size: 1.6rem;
          font-family: Source Han Sans CN, Source Han Sans CN-Normal;
          font-weight: Normal;
          text-align: LEFT;
          color: #999999;
          letter-spacing: 0rem;
        }
      }
    }

    //导航
    .topNav {
      width: 100%;
      height: 5.6rem;
      padding: 1.1rem 0rem 1.1rem 1.8rem;
      overflow-x: scroll;
      overflow-y: hidden;
      white-space: nowrap;

      .navContent {
        padding: 0 1rem;
        height: 3.4rem;
        border-radius: 1.7rem;
        overflow: hidden;
        display: inline-block;

        .navList {
          height: 3.4rem;
          display: flex;
          justify-content: center;
          align-items: center;

          .navIcon {
            width: 2.4rem;
            height: 2.4rem;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .navText {
            font-size: 1.4rem;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            text-align: LEFT;
            color: #333333;
            line-height: 2.4rem;
            letter-spacing: 0rem;
          }
        }
      }

      .navContent-active {
        background: #fad850;
      }
    }

    ::-webkit-scrollbar {
      display: none;
      width: 0;
    }
  }

  //右侧选择*****************************************
  .rightSelect {
    width: 4.8rem;
    height: 10.8rem;
    position: absolute;
    right: 1.6rem;
    top: 15.4rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .selectContent1 {
      width: 4.8rem;
      height: 4.8rem;
      background: #fafafa;
      border-radius: 0.8rem;
      box-shadow: 0rem 0.4rem 0.8rem 0rem rgba(0, 0, 0, 0.06);
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;

      .lineText2 {
        width: 4rem;
        height: 1.4rem;
        font-size: 1rem;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: CENTER;
        color: #333333;
        line-height: 1rem;
        letter-spacing: 0rem;
      }
    }

    .selectContent2 {
      width: 4.8rem;
      height: 4.8rem;
      background: #fafafa;
      border-radius: 0.8rem;
      box-shadow: 0rem 0.4rem 0.8rem 0rem rgba(0, 0, 0, 0.06);
      display: flex;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;

      .lineIcon2 {
        width: 2.4rem;
        height: 2.4rem;
        background: url("./image/icon_route.svg") no-repeat;
        background-size: 100%;
      }

      .lineText2 {
        width: 4rem;
        height: 1.4rem;
        font-size: 1rem;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: CENTER;
        color: #333333;
        line-height: 1rem;
        letter-spacing: 0rem;
      }
    }
  }

  //底部列表******************************************
  .bottomAll {
    width: 100%;
    overflow: hidden;
    position: fixed;
    bottom: 0;
    z-index: 1;

    .bottomList {
      width: 100%;
      height: 4.8rem;
      background: #fafafa;
      border-radius: 1.2rem 1.2rem 0rem 0rem;
      display: flex;
      justify-content: center;
      align-items: center;

      .listBtn {
        width: 9rem;
        height: 2rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .listIcon {
          width: 2rem;
          height: 2rem;
          background: url("./image/icon_list.svg") no-repeat;
          background-size: 100%;
        }

        .listText {
          font-size: 1.6rem;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: LEFT;
          color: #333333;
          line-height: 1.6rem;
          letter-spacing: 0rem;
        }
      }

      .listBtn-active {
        width: 4.4rem;
        height: 1.8rem;
        background: url("./image/xiala.svg") no-repeat;
        background-size: 100%;
      }
    }

    .listContent {
      width: 100%;
      height: 49.5rem;
      background: #fafafa;
      display: flex;
      flex-direction: column;
      align-items: center;
      overflow: auto;

      .conDetail {
        width: 34rem;
        height: 11.2rem;
        background: #ffffff;
        border-radius: 0.6rem;
        margin-bottom: 1.2rem;
        padding: 0.6rem;
        display: flex;
        justify-content: space-between;

        .leftImg {
          width: 10rem;
          height: 10rem;
          border-radius: 0.6rem;
          background: aquamarine;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .rightIntro {
          width: 21.6rem;
          height: 10rem;
          padding: 1rem 0 0.7rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .introName {
            width: 100%;
            height: 2.5rem;
            font-size: 1.8rem;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            text-align: LEFT;
            color: #333333;
            line-height: 2.5rem;
            letter-spacing: 0rem;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
          }

          .introBottom {
            width: 100%;
            height: 4.4rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .bottomAddress {
              width: 100%;
              height: 2rem;
              display: flex;
              align-items: center;

              .addressIcon {
                width: 1.6rem;
                height: 1.6rem;
                background: url("./image/icon_address.svg") no-repeat;
                background-size: 100%;
                flex-shrink: 0;
              }

              .addressName {
                height: 2rem;
                font-size: 1.4rem;
                font-family: PingFang SC, PingFang SC-Regular;
                font-weight: 400;
                text-align: LEFT;
                color: #666666;
                line-height: 2rem;
                letter-spacing: 0rem;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
              }
            }

            .bottomLook {
              width: 100%;
              height: 2rem;
              display: flex;
              justify-content: space-between;

              .lookLeft {
                width: 50%;
                height: 2rem;
                display: flex;
                align-items: center;

                .lookIcon {
                  width: 1.6rem;
                  height: 1.6rem;
                  background: url("./image/icon_eye.svg") no-repeat;
                  background-size: 100%;
                }

                .lookNum {
                  width: 50%;
                  height: 2rem;
                  font-size: 1.4rem;
                  font-family: PingFang SC, PingFang SC-Regular;
                  font-weight: 400;
                  text-align: LEFT;
                  color: #666666;
                  line-height: 2rem;
                }
              }

              .lookRight {
                height: 2rem;
                text-align: right;
                line-height: 2rem;
                font-size: 1.2rem;
                font-family: PingFang SC, PingFang SC-Light;
                font-weight: 300;
                color: #666666;
              }
            }
          }
        }
      }
    }
  }

  //弹窗*************************************************
  .skipWindow {
    width: 34rem;
    background: #ffffff;
    border-radius: 0.6rem;
    position: absolute;
    left: 50%;
    margin-left: -17rem;
    bottom: 0.9rem;
    z-index: 1;

    .conDetail {
      width: 100%;
      height: 9.6rem;
      background: #ffffff;
      padding: 0.6rem 0.6rem 1rem;
      display: flex;
      justify-content: space-between;

      .leftImg {
        width: 8rem;
        height: 8rem;
        border-radius: 0.4rem;
        background: aquamarine;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .rightIntro {
        width: 23.8rem;
        height: 8rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .introName {
          width: 100%;
          height: 2.5rem;
          font-size: 1.8rem;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: LEFT;
          color: #333333;
          line-height: 2.5rem;
          letter-spacing: 0rem;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
        }

        .introBottom {
          width: 100%;
          height: 4.4rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .bottomAddress {
            width: 100%;
            height: 2rem;
            display: flex;
            align-items: center;

            .addressIcon {
              width: 1.6rem;
              height: 1.6rem;
              background: url("./image/icon_address.svg") no-repeat;
              background-size: 100%;
              flex-shrink: 0;
            }

            .addressName {
              height: 2rem;
              font-size: 1.4rem;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              text-align: LEFT;
              color: #666666;
              line-height: 2rem;
              letter-spacing: 0rem;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;
            }
          }

          .bottomLook {
            width: 100%;
            height: 2rem;
            display: flex;
            justify-content: space-between;

            .lookLeft {
              height: 2rem;
              display: flex;
              align-items: center;

              .lookIcon {
                width: 1.6rem;
                height: 1.6rem;
                background: url("./image/icon_eye.svg") no-repeat;
                background-size: 100%;
              }

              .lookNum {
                height: 2rem;
                font-size: 1.4rem;
                font-family: PingFang SC, PingFang SC-Regular;
                font-weight: 400;
                text-align: LEFT;
                color: #666666;
                line-height: 2rem;
              }
            }

            .lookRight {
              height: 2rem;
              text-align: right;
              line-height: 2rem;
              font-size: 1.2rem;
              font-family: PingFang SC, PingFang SC-Light;
              font-weight: 300;
              color: #666666;
            }
          }
        }
      }
    }

    .skipBottom {
      width: 100%;
      padding: 0 0.8rem;

      // 音频
      .audio {
        width: 100%;
        height: 4.4rem;
        display: flex;
        align-items: center;
        box-sizing: border-box;

        .icon_play {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 3rem;
          height: 3rem;
          border-radius: 50%;
          background: #f85f5f;
        }

        .audio-box {
          width: 100%;
          height: 4.4rem;

          .player-box {
            width: 100%;
            height: 4.4rem;
            box-shadow: 0.1rem 0.1rem 0.6rem 0rem rgba(0, 0, 0, 0.05);
            justify-content: space-between;
            padding: 0 0 0 0.8rem;
            // margin: 0.4rem auto 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #faf7f2;

            .audio-left {
              /* float: left; */
              margin-right: 0.4rem;
              width: 3.6rem;
              height: 3.6rem;
              border-radius: 50%;
              display: flex;
              justify-content: center;
              align-items: center;

              a {
                width: 3.6rem;
                height: 3.6rem;

                img {
                  width: 100%;
                  height: 100%;
                }
              }
            }

            #audioPlayer {
              cursor: pointer;
            }

            .audio-right {
              flex: 1;
              width: 0;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding-left: 0.5rem;

              .progress-bar-bg {
                width: 16rem;
                background: #f0f0f0;
                position: relative;
                height: 0.4rem;
                cursor: pointer;
                border-radius: 0.4rem;

                span {
                  content: " ";
                  width: 1rem;
                  height: 1rem;
                  border-radius: 50%;
                  background-color: #fad850;
                  position: absolute;
                  left: 0;
                  top: 50%;
                  margin-top: -0.5rem;
                  margin-left: -0.5rem;
                  cursor: pointer;
                  z-index: 2;
                }

                .progress-bar {
                  background-color: #fad850;
                  width: 0;
                  height: 0.4rem;
                  // margin-top: -0.01rem;
                  border-radius: 0.4rem;
                  position: absolute;
                  top: 50%;
                  left: 0;
                  transform: translateY(-50%);
                  z-index: 1;
                }
              }

              .audio-time {
                width: 10rem;
                height: 1.7rem;
                overflow: hidden;
                color: #999999;
                justify-content: flex-start;
                // margin-top: 0.16rem;
                line-height: 1.7rem;
                font-size: 1.2rem;
                display: flex;
                align-items: center;
              }
            }
          }
        }
      }

      //
      .skipSelect {
        width: 100%;
        height: 4.6rem;
        display: flex;
        justify-content: space-around;
        align-items: center;

        .skipReserve {
          width: 9rem;
          height: 4rem;
          font-size: 1.4rem;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          text-align: CENTER;
          color: #333333;
          line-height: 4rem;
          background: #fad950;
          border-radius: 0.4rem;
        }

        .leftSkip {
          width: 9rem;
          height: 4rem;
          display: flex;
          justify-content: center;
          align-items: center;

          .skipText {
            height: 2rem;
            font-size: 1.4rem;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: CENTER;
            color: #333333;
            line-height: 2rem;
          }
        }

        .rightSkip {
          width: 9rem;
          height: 4rem;
          display: flex;
          justify-content: center;
          align-items: center;

          .skipIcon {
            width: 1.8rem;
            height: 1.8rem;
            background: url("./image/icon_navgation.svg") no-repeat;
            background-size: 100%;
          }

          .skipText {
            height: 2rem;
            font-size: 1.4rem;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: CENTER;
            color: #4971ff;
            line-height: 2rem;
          }
        }
      }
    }
  }

  //导航*******************************************
  .navigation {
    width: 100%;
    height: 5.2rem;
    position: fixed;
    bottom: 1.6rem;
    padding: 0 7.2rem 0 1.6rem;
    display: flex;
    justify-content: space-between;

    .leftCon {
      width: 5.2rem;
      height: 5.2rem;
      background: #ffffff;
      border-radius: 0.6rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .leftIcon {
        width: 2rem;
        height: 2rem;
        background: url("./image/icon_escape.svg") no-repeat;
        background-size: 100%;
        flex-shrink: 0;
      }

      .leftText {
        width: 3.2rem;
        height: 2.2rem;
        font-size: 1.6rem;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: CENTER;
        color: #333333;
        line-height: 2.2rem;
        letter-spacing: 0rem;
      }
    }

    .rightCon {
      width: 23rem;
      height: 5.2rem;
      background: #ffffff;
      border-radius: 0.6rem;
      display: flex;
      justify-content: center;
      align-items: center;

      .leftIcon {
        width: 2rem;
        height: 2rem;
        background: url("./image/icon_navgation.svg") no-repeat;
        background-size: 100%;
        flex-shrink: 0;
      }

      .leftText {
        width: 6.4rem;
        height: 2.2rem;
        font-size: 1.6rem;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: CENTER;
        color: #4971ff;
        line-height: 2.2rem;
        letter-spacing: 0rem;
      }
    }
  }

  //详情页面
  .detail {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    background: #fafafa;
    overflow: auto;
    z-index: 100;

    // 轮播
    .swiper {
      width: 100%;
      height: 25.5rem;
      background: aqua;
      margin-bottom: 12rem;

      .van-swipe {
        width: 100%;
        height: 100%;

        .van-swipe-item {
          width: 100%;
          height: 100%;

          img {
            width: 100% !important;
            height: 100% !important;
          }
        }

        .custom-indicator {
          width: 5.6rem;
          height: 2.4rem;
          background: #000000;
          color: #fff;
          border-radius: 1.2rem;
          position: absolute;
          right: 12px;
          bottom: 30px;
          padding: 2px 5px;
          font-size: 12px;
          background: rgba(0, 0, 0, 0.3);
          display: flex;
          justify-content: space-around;
          align-items: center;

          .imgIcon {
            width: 1.8rem;
            height: 1.8rem;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }

    // 卡片
    .introCard {
      width: 34.4rem;
      height: 11.8rem;
      padding: 1.6rem;
      position: absolute;
      top: 23rem;
      left: 50%;
      margin-left: -17.2rem;
      background: #ffffff;
      border-radius: 0.8rem;
      box-shadow: 0rem 0.4rem 0.8rem 0rem rgba(0, 0, 0, 0.04);
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .introName {
        width: 100%;
        height: 3rem;
        height: 3rem;
        font-size: 2rem;
        font-family: Source Han Sans CN, Source Han Sans CN-Medium;
        font-weight: 500;
        text-align: LEFT;
        color: #333333;
        line-height: 3rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
      }

      .change {
        width: 100%;
        height: 5rem;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .introYear {
          width: 100%;
          height: 2rem;
          display: flex;
          align-items: center;

          .yearIcon {
            width: 1.6rem;
            height: 1.6rem;
            background: url("./image/icon_time.svg") no-repeat;
            background-size: 100%;
          }

          .yearText {
            height: 2rem;
            font-size: 1.4rem;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: LEFT;
            color: #666666;
            line-height: 2rem;
            margin-left: 0.5rem;
          }
        }

        .introAddress {
          width: 100%;
          height: 2rem;
          display: flex;
          align-items: center;

          .addressIcon {
            width: 1.6rem;
            height: 1.6rem;
            background: url("./image/icon_address.svg") no-repeat;
            background-size: 100%;
            flex-shrink: 0;
          }

          .addressText {
            height: 2rem;
            font-size: 1.4rem;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: LEFT;
            color: #666666;
            line-height: 2rem;
            margin-left: 0.5rem;
          }
        }
      }
    }

    //简介
    .synopsis {
      width: 100%;
      padding: 0 1.8rem 3.2rem;

      .chat {
        width: 100%;
        height: 5rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-bottom: 1.2rem;

        .chatTime,
        .chatTel {
          width: 100%;
          height: 2rem;

          .timeName,
          .telName {
            width: 5.6rem;
            height: 2rem;
            font-size: 1.4rem;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: LEFT;
            color: #999999;
            line-height: 2rem;
            letter-spacing: 0rem;
            margin-right: 2.4rem;
          }

          .timeCon,
          .telCon {
            width: 10.4rem;
            height: 2rem;
            font-size: 1.4rem;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: LEFT;
            color: #333333;
            line-height: 2rem;
          }

          .tel {
            width: 5rem;
            height: 2rem;
            float: right;

            .telIcon {
              width: 1.8rem;
              height: 1.8rem;
              background: url("./image/icon_call.svg") no-repeat;
              background-size: 100%;
              float: left;
            }

            .telText {
              width: 2.8rem;
              height: 2rem;
              font-size: 1.4rem;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: #4971ff;
              line-height: 2rem;
              float: right;
            }
          }
        }
      }

      .introTitle {
        width: 100%;
        height: 3rem;
        display: flex;
        // align-items: center;
        font-size: 1.8rem;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 600;
        text-align: LEFT;
        color: #333333;
      }

      .syCon {
        width: 100%;
        font-size: 1.4rem;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: LEFT;
        color: #666666;
        line-height: 2.4rem;
      }
    }

    // 周边
    .round {
      width: 100%;
      padding-left: 1.6rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-bottom: 10rem;

      .roundAll {
        width: 100%;
        height: 22.9rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-bottom: 1.5rem;

        .roundTitle {
          width: 100%;
          height: 2.5rem;
          padding: 0 1.6rem 0 0;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .titleLeft {
            width: 7.2rem;
            height: 2.5rem;
            font-size: 1.8rem;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            text-align: LEFT;
            color: #333333;
            line-height: 2.5rem;
          }

          .titleRight {
            width: 7.2rem;
            height: 2rem;
            font-size: 1.4rem;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            text-align: LEFT;
            color: #333333;
            line-height: 2rem;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .toIcon {
              width: 1.6rem;
              height: 1.6rem;
              background: url("./image/to.svg") no-repeat;
              background-size: 100%;
            }
          }
        }

        .roundNav {
          width: 100%;
          height: 4rem;
          overflow-x: scroll;
          overflow-y: hidden;
          white-space: nowrap;

          .navList {
            width: 7.6rem;
            height: 3.4rem;
            background: #f6f6f6;
            border-radius: 1.7rem;
            font-size: 1.4rem;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: center;
            color: #333333;
            line-height: 3.4rem;
            letter-spacing: 0rem;
            display: inline-block;
            margin-right: 0.4rem;
          }

          .navList-active {
            background: #fad850;
          }
        }

        .roundCon {
          width: 100%;
          height: 13.4rem;
          overflow-x: scroll;
          overflow-y: hidden;
          white-space: nowrap;

          .conList {
            width: 10rem;
            height: 13.4rem;
            margin-right: 0.8rem;
            border-radius: 0.4rem;
            display: inline-block;
            overflow: hidden;

            .listImg {
              width: 10rem;
              height: 8rem;
              overflow: hidden;
              background: aqua;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .listIntro {
              width: 100%;
              height: 5.3rem;
              padding: 0.6rem;
              background: #7f8289;
              display: flex;
              flex-direction: column;
              justify-content: space-between;

              .introName {
                width: 100%;
                height: 2rem;
                font-size: 1.4rem;
                font-family: PingFang SC, PingFang SC-Medium;
                font-weight: 500;
                text-align: LEFT;
                color: #ffffff;
                line-height: 2rem;
                letter-spacing: 0rem;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
              }

              .introCon {
                width: 100%;
                height: 1.4rem;
                font-size: 1rem;
                font-family: PingFang SC, PingFang SC-Light;
                font-weight: 300;
                text-align: LEFT;
                color: #f0f0f0;
                line-height: 1rem;
              }
            }
          }
        }

        ::-webkit-scrollbar {
          display: none;
          width: 0px;
        }
      }
    }

    .round-active {
      width: 100%;
      padding-left: 1.6rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-bottom: 4.8rem;
    }

    .bottom {
      width: 100%;
      position: fixed;
      bottom: 0;
      background: #fff;

      // 音频
      .audio {
        width: 32.4rem;
        height: 4.4rem;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        margin: 1.6rem auto 0;

        .icon_play {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 3rem;
          height: 3rem;
          border-radius: 50%;
          background: #f85f5f;
        }

        .audio-box {
          width: 100%;
          height: 4.4rem;

          .player-box {
            width: 100%;
            height: 4.4rem;
            box-shadow: 0.1rem 0.1rem 0.6rem 0rem rgba(0, 0, 0, 0.05);
            justify-content: space-between;
            padding: 0 0 0 0.8rem;
            // margin: 0.4rem auto 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #faf7f2;

            .audio-left {
              /* float: left; */
              margin-right: 0.4rem;
              width: 3.6rem;
              height: 3.6rem;
              border-radius: 50%;
              display: flex;
              justify-content: center;
              align-items: center;

              a {
                width: 3.6rem;
                height: 3.6rem;

                img {
                  width: 100%;
                  height: 100%;
                }
              }
            }

            #audioPlayer {
              cursor: pointer;
            }

            .audio-right {
              flex: 1;
              width: 0;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding-left: 0.5rem;

              .progress-bar-bg {
                width: 16rem;
                background: #f0f0f0;
                position: relative;
                height: 0.4rem;
                cursor: pointer;
                border-radius: 0.4rem;

                span {
                  content: " ";
                  width: 1rem;
                  height: 1rem;
                  border-radius: 50%;
                  background-color: #fad850;
                  position: absolute;
                  left: 0;
                  top: 50%;
                  margin-top: -0.5rem;
                  margin-left: -0.5rem;
                  cursor: pointer;
                  z-index: 2;
                }

                .progress-bar {
                  background-color: #fad850;
                  width: 0;
                  height: 0.4rem;
                  // margin-top: -0.01rem;
                  border-radius: 0.4rem;
                  position: absolute;
                  top: 50%;
                  left: 0;
                  transform: translateY(-50%);
                  z-index: 1;
                }
              }

              .audio-time {
                width: 10rem;
                height: 1.7rem;
                overflow: hidden;
                color: #999999;
                justify-content: flex-start;
                // margin-top: 0.16rem;
                line-height: 1.7rem;
                font-size: 1.2rem;
                display: flex;
                align-items: center;
              }
            }
          }
        }
      }

      //返回
      .roundSelect {
        width: 100%;
        height: 4.8rem;
        padding-right: 1.6rem;
        display: flex;
        justify-content: space-around;
        align-items: center;

        .seOne {
          width: 5rem;
          height: 2rem;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .oneIcon {
            width: 1.8rem;
            height: 1.8rem;
            background: url("./image/icon_back.svg") no-repeat;
            background-size: 100%;
          }

          .oneText {
            width: 2.8rem;
            height: 2rem;
            font-size: 1.4rem;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: CENTER;
            color: #333333;
            line-height: 2rem;
          }
        }

        .seTwo {
          width: 5rem;
          height: 2rem;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .twoIcon {
            width: 1.8rem;
            height: 1.8rem;
            background: url("./image/yuding.svg") no-repeat;
            background-size: 100%;
          }

          .twoText {
            width: 2.8rem;
            height: 2rem;
            font-size: 1.4rem;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: CENTER;
            color: #333333;
            line-height: 2rem;
          }
        }

        .seThree {
          width: 5rem;
          height: 2rem;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .threeIcon {
            width: 1.8rem;
            height: 1.8rem;
            background: url("./image/icon_navgation.svg") no-repeat;
            background-size: 100%;
          }

          .threeText {
            width: 2.8rem;
            height: 2rem;
            font-size: 1.4rem;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: CENTER;
            color: #4971ff;
            line-height: 2rem;
          }
        }
      }
    }
  }

  //更多推荐*************************************
  .rounder {
    width: 100%;
    height: 100vh;
    background: #fafafa;
    padding: 1.6rem 1.25rem 4.8rem;
    position: fixed;
    top: 0;
    z-index: 100;
    overflow: auto;
    // display: flex;
    display: -webkit-flex;
    /* safari */
    justify-content: space-between;
    flex-wrap: wrap;

    .roundCon {
      flex: 0 0 48.3%;
      width: 16.5rem;
      height: 19.6rem;
      margin-bottom: 1.5rem;
      background: #ffffff;
      border-radius: 0.8rem;
      overflow: hidden;
      display: inline-block;

      .conImg {
        width: 100%;
        height: 13.2rem;
        background: aqua;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .conIntro {
        width: 100%;
        height: 6.4rem;
        padding: 0.8rem 0.8rem 1rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .introName {
          width: 100%;
          height: 2rem;
          font-size: 1.4rem;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: LEFT;
          color: #333333;
          line-height: 2rem;
          letter-spacing: 0rem;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
        }

        .introDetail {
          width: 100%;
          height: 2rem;
          display: flex;

          .leftDe {
            width: 50%;
            height: 2rem;
            display: flex;
            align-items: center;

            .leftIcon {
              width: 1.6rem;
              height: 1.6rem;
              background: url("./image/icon_eye.svg") no-repeat;
              background-size: 100%;
              float: left;
              flex-shrink: 0;
            }

            .leftText {
              font-size: 1.4rem;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              text-align: LEFT;
              color: #666666;
            }
          }

          .rightDe {
            width: 50%;
            height: 2rem;
            display: flex;
            justify-content: end;
            align-items: center;

            .rightText {
              font-size: 1.2rem;
              font-family: PingFang SC, PingFang SC-Light;
              font-weight: 300;
              text-align: center;
              color: #666666;
            }
          }
        }
      }
    }

    .backPage {
      width: 100%;
      height: 4.8rem;
      position: fixed;
      bottom: 0;
      background: #fff;
      z-index: 300;
      display: flex;
      justify-content: center;
      align-items: center;

      .backBtn {
        width: 4.2rem;
        height: 2rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .backIcon {
          width: 1.3rem;
          height: 1.2rem;
          flex-shrink: 0;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .backText {
          width: 2.8rem;
          height: 2rem;
          font-size: 1.4rem;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          text-align: CENTER;
          color: #333333;
          line-height: 2rem;
        }
      }
    }
  }

  //路线页面
  .route {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    z-index: 100;

    .top {
      width: 100%;
      height: 4.8rem;
      position: absolute;
      top: 0;
      padding: 1.3rem 1.8rem;
      border-bottom: 0.1rem solid #eee;
      display: flex;
      background: #fafafa;

      .topLeft {
        width: 5rem;
        height: 2.2rem;
        display: flex;
        align-items: center;
        float: left;

        .backIcon {
          width: 2rem;
          height: 2rem;
        }

        .backText {
          width: 2.8rem;
          height: 2rem;
          font-size: 1.4rem;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          text-align: CENTER;
          color: #333333;
          line-height: 2rem;
        }
      }

      .topTitle {
        width: 3.2rem;
        height: 2.2rem;
        font-size: 1.6rem;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        color: #333333;
        line-height: 2.2rem;
        letter-spacing: 0rem;
        position: absolute;
        left: 50%;
        margin-left: -1.6rem;
      }
    }

    .content {
      width: 100%;
      height: 100%;
      padding: 4.8rem 1.65rem 0;
      background: #fafafa;
      overflow: auto;

      .contents {
        width: 100%;
        display: flex;
        display: -webkit-flex;
        /* safari */
        justify-content: space-between;
        flex-wrap: wrap;

        .contentList {
          flex: 0 0 48.5%;
          width: 16.5rem;
          height: 21.6rem;
          display: inline-block;

          .listImg {
            width: 16.5rem;
            height: 13.2rem;
            border-radius: 0.8rem 0.8rem 0rem 0rem;
            background: aqua;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .listDetail {
            width: 100%;
            height: 6.4rem;
            padding: 0.8rem 0.8rem 1rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            background: #fff;

            .detailName {
              width: 100%;
              height: 2rem;
              font-size: 1.4rem;
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              text-align: LEFT;
              color: #333333;
              line-height: 2rem;
              letter-spacing: 0rem;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }

            .detailData {
              width: 60%;
              height: 2rem;
              display: flex;

              .leftCon {
                width: 50%;
                height: 2rem;
                display: flex;
                align-items: center;

                .leftIcon {
                  width: 1.8rem;
                  height: 1.8rem;
                  background: url("./image/icon_location.svg") no-repeat;
                  background-size: 100%;
                  flex-shrink: 0;
                }

                .leftNum {
                  height: 2rem;
                  font-size: 1.4rem;
                  font-family: PingFang SC, PingFang SC-Regular;
                  font-weight: 400;
                  text-align: LEFT;
                  color: #666666;
                  line-height: 2rem;
                }
              }

              .rightCon {
                width: 50%;
                height: 2rem;
                display: flex;
                align-items: center;

                .rightIcon {
                  width: 1.8rem;
                  height: 1.8rem;
                  background: url("./image/icon_picture.svg") no-repeat;
                  background-size: 100%;
                }

                .rightNum {
                  height: 2rem;
                  font-size: 1.4rem;
                  font-family: PingFang SC, PingFang SC-Regular;
                  font-weight: 400;
                  text-align: LEFT;
                  color: #666666;
                  line-height: 2rem;
                }
              }
            }
          }
        }
      }
    }
  }

  // 头部
  .topDet {
    width: 100%;
    height: 4.8rem;
    position: absolute;
    top: 0;
    padding: 1.3rem 1.8rem;
    border-bottom: 0.1rem solid #eee;
    display: flex;
    background: #fafafa;

    .topLeft {
      width: 5rem;
      height: 2.2rem;
      display: flex;
      align-items: center;
      float: left;

      .backIcon {
        width: 2rem;
        height: 2rem;
      }

      .backText {
        width: 2.8rem;
        height: 2rem;
        font-size: 1.4rem;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: CENTER;
        color: #333333;
        line-height: 2rem;
      }
    }

    .topTitle {
      width: 20rem;
      height: 2.2rem;
      font-size: 1.6rem;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: #333333;
      line-height: 2.2rem;
      letter-spacing: 0rem;
      position: absolute;
      left: 50%;
      margin-left: -10rem;
      text-align: center;
    }
  }

  // 底部
  .bottomDet {
    width: 100%;
    background: #fafafa;
    border-radius: 1.2rem 1.2rem 0rem 0rem;
    position: absolute;
    bottom: 0;
    z-index: 1;

    .bottomTop {
      width: 100%;
      height: 3.2rem;
      margin-bottom: 0.8rem;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;

      .topIcon {
        width: 6.4rem;
        height: 0.5rem;
        background: #cfcfcf;
        border-radius: 0.3rem;
      }
    }

    .bottomCon {
      width: 100%;
      height: 15.8rem;
      padding: 0 1.75rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .conName {
        width: 100%;
        height: 2.5rem;
        font-size: 1.8rem;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: LEFT;
        color: #333333;
        line-height: 2.5rem;
        letter-spacing: 0rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
      }

      .conLine {
        width: 100%;
        height: 7.8rem;
        background: #ffcd6c;
        border-radius: 0.8rem;
        padding: 1.2rem 1.6rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .lineCon {
          width: 100%;
          height: 2.2rem;
          display: flex;
          align-items: center;

          .startMarker {
            height: 2.2rem;
            display: flex;
            align-items: center;

            .start {
              width: 0.6rem;
              height: 0.6rem;
              background: #4d7eff;
              border-radius: 50%;
              margin-right: 0.6rem;
              flex-shrink: 0;
            }

            .startName {
              height: 2.2rem;
              font-size: 1.6rem;
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              text-align: LEFT;
              color: #333333;
              line-height: 2.2rem;
              letter-spacing: 0rem;
            }
          }

          .toIcon {
            width: 1.6rem;
            height: 0.5rem;
            background: url("./image/to2.svg") no-repeat;
            background-size: 100%;
            margin: 0 1rem;
          }

          .endMarker {
            height: 2.2rem;
            display: flex;
            align-items: center;

            .end {
              width: 0.6rem;
              height: 0.6rem;
              background: #44da89;
              border-radius: 50%;
              margin-right: 0.6rem;
              flex-shrink: 0;
            }

            .endName {
              height: 2.2rem;
              font-size: 1.6rem;
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              text-align: LEFT;
              color: #333333;
              line-height: 2.2rem;
              letter-spacing: 0rem;
            }
          }
        }

        .lineDetail {
          width: 100%;
          height: 2rem;
          display: flex;
          justify-content: space-between;

          .detLeft {
            height: 2rem;
            font-size: 1.4rem;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: LEFT;
            color: #766648;
            line-height: 2rem;
            letter-spacing: 0rem;

            .detTT {
              height: 2rem;
              font-size: 1.4rem;
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              text-align: LEFT;
              color: #333333;
              line-height: 2rem;
              letter-spacing: 0rem;
            }
          }
        }
      }

      .lineIntro {
        width: 7.2rem;
        height: 2.5rem;
        font-size: 1.8rem;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: LEFT;
        color: #333333;
        line-height: 1.8rem;
      }
    }

    .bottomIntro {
      width: 100%;
      height: 35.1rem;
      padding: 1.6rem 1.6rem 0;

      .introImg {
        width: 100%;
        height: 10.8rem;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;

        .allList {
          width: 100%;
          height: 10.8rem;
          overflow-x: scroll;
          overflow-y: hidden;
          white-space: nowrap;

          .imgList {
            width: 10.8rem;
            height: 10.8rem;
            border-radius: 0.4rem;
            background: #44da89;
            margin: 0 0.3rem;
            display: inline-block;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }

        ::-webkit-scrollbar {
          display: none;
        }
      }

      .introText {
        width: 100%;
        height: 16.8rem;
        margin-top: 1.6rem;
        overflow: auto;
        font-size: 1.4rem;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: LEFT;
        color: #666666;
        line-height: 2.4rem;
      }

      .toStart {
        width: 100%;
        height: 4.3rem;
        display: flex;
        justify-content: center;
        align-items: center;

        .startBtn {
          width: 9rem;
          height: 2.2rem;
          font-size: 1.6rem;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: CENTER;
          color: #333333;
          line-height: 2.2rem;
          display: flex;
          align-items: center;

          .startIcon {
            width: 1.6rem;
            height: 1.6rem;
            display: inline-block;
            background: url("./image/to3.svg") no-repeat;
            background-size: 100%;
            margin-left: 0.5rem;
          }
        }
      }
    }
  }

  //搜索页面
  .search {
    width: 100%;
    height: 100vh;
    background: #fafafa;
    padding: 0.9rem 1.6rem 0;
    position: absolute;
    top: 0;
    z-index: 300;

    //搜索框
    .search-box {
      width: 100%;
      height: 3rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0.5rem 0;
      position: relative;

      input {
        width: 30rem;
        height: 4.4rem;
        background: #ffffff;
        border-radius: 4.4rem;
        padding-left: 3rem;
        border: #fff;
        outline: none;
      }

      input:focus {
        outline: none;
      }

      .serchbtn {
        width: 2.4rem;
        height: 2.4rem;
        background: url("./image/icon_search.svg") no-repeat;
        background-size: 100%;
        position: absolute;
        top: 0.2rem;
        left: 0.5rem;
      }

      .onCancle {
        width: 4rem;
        height: 3rem;
        font-size: 1.6rem;
        border-radius: 3rem;
        font-weight: 500;
        text-align: center;
        line-height: 3rem;
        color: #43525c;
      }
    }

    //搜索内容
    .searchContent {
      width: 100%;
      position: relative;

      .sContent {
        width: 100%;
        height: 5rem;
        border-bottom: 1px solid #eee;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .scenicItem {
          width: 100%;
          height: 3rem;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .leftItem {
            display: flex;

            .itemIcon {
              width: 2.2rem;
              height: 2.2rem;
              margin-right: 0.5rem;
            }

            .itemName {
              height: 2.2rem;
              line-height: 2.2rem;
              font-size: 1.6rem;
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              text-align: LEFT;
              color: #333333;
              letter-spacing: 0rem;
            }
          }

          .rightItem {
            height: 2.2rem;
            font-size: 1.4rem;
            font-family: Source Han Sans CN, Source Han Sans CN-Normal;
            font-weight: Normal;
            color: #666666;
            line-height: 2.2rem;
            letter-spacing: 0rem;
          }
        }
      }

      .noResult {
        position: absolute;
        top: 5rem;
        height: 3rem;
        margin-left: 7rem;
      }
    }

    //历史记录内容
    .histroyContent {
      width: 100%;

      .histroyList {
        height: 5rem;
        padding: 1.1rem 0;
        display: flex;
        align-items: center;
        border-bottom: 0.1rem solid #eee;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .all {
          display: flex;

          .icon_scenic {
            width: 2.2rem;
            height: 2.2rem;
            background: chartreuse;
            margin-right: 0.5rem;
          }

          .areaName {
            height: 2.2rem;
            font-size: 1.6rem;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            text-align: LEFT;
            color: #333333;
            line-height: 2.2rem;
            letter-spacing: 0rem;
          }
        }

        .areaTitle {
          height: 2.2rem;
          font-size: 1.4rem;
          font-family: Source Han Sans CN, Source Han Sans CN-Normal;
          font-weight: Normal;
          color: #666666;
          line-height: 2.2rem;
          letter-spacing: 0rem;
        }
      }
    }
  }

  //异性轮播图
  .banner-box-swiper {
    width: 100%;
    height: 14rem;
    overflow: hidden;
    position: absolute;
    bottom: 0.9rem;
    z-index: 500;

    .swiper-container {
      height: 14rem;
      width: 34rem;
      overflow: visible;

      .swiper-slide {
        text-align: center;
        background: #fff;
        transition: 300ms;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 1.2rem 1.2rem 1.4rem;

        .topTitle {
          width: 100%;
          height: 2rem;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .leftCon {
            height: 2rem;

            .leftIcon {
              width: 2rem;
              height: 2rem;
              border-radius: 50%;
              color: #000000;
              text-align: center;
              line-height: 2rem;
              float: left;
              background: #ffcd6c;
              margin-right: 0.5rem;
              flex-shrink: 0;
            }

            .leftText {
              font-size: 1.8rem;
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              text-align: LEFT;
              color: #333333;
              line-height: 2rem;
              letter-spacing: 0rem;
            }
          }

          .rightCon {
            width: 2rem;
            height: 2rem;
            background: url("./image/icon_close.svg") no-repeat;
            background-size: 100%;
          }
        }

        .centerCon {
          width: 100%;
          height: 6rem;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .centerLeft {
            width: 22.5rem;
            height: 4.8rem;
            font-size: 1.4rem;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: LEFT;
            color: #666666;
            line-height: 2.4rem;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }

          .centerRight {
            width: 8rem;
            height: 6rem;
            border-radius: 0.4rem;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }

        .bottomCon {
          width: 100%;
          height: 3rem;
          display: flex;
          justify-content: space-around;
          align-items: center;

          .leftAll {
            width: 9rem;
            height: 3rem;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .leftIndex {
              width: 2.4rem;
              height: 2.4rem;
              background: url("./image/past.svg") no-repeat;
              background-size: 100%;
            }

            .bottomLeft {
              width: 3rem;
              height: 3rem;
              border-radius: 50%;
              background: url("./image/button_play.svg") no-repeat;
              background-size: 100%;
            }

            .bottomLeft-active {
              width: 3rem;
              height: 3rem;
              border-radius: 50%;
              background: url("./image/icon_zanting.svg") no-repeat;
              background-size: 100%;
            }

            .rightIndex {
              width: 2.4rem;
              height: 2.4rem;
              background: url("./image/next.svg") no-repeat;
              background-size: 100%;
            }
          }

          .bottomCenter {
            width: 5.6rem;
            height: 2rem;
            font-size: 1.4rem;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: CENTER;
            color: #333333;
            line-height: 1.4rem;
          }

          .bottomRight {
            width: 5rem;
            height: 2rem;

            .rightIcon {
              width: 2rem;
              height: 2rem;
              float: left;
              background: url("./image/icon_navgation.svg") no-repeat;
              background-size: 100%;
            }

            .rightText {
              width: 2.8rem;
              height: 2rem;
              float: right;
              font-size: 1.4rem;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              text-align: LEFT;
              color: #4971ff;
              line-height: 2rem;
            }
          }
        }
      }

      .swiper-slide-next,
      .swiper-slide-prev {
        height: 100%;
      }
    }
  }
}
</style>